module.exports = __webpack_public_path__ + "fonts/Inter-900-cyrillic-ext78.857026d.woff2";